/**
 * WorldMapPage — geographic coverage of the knowledge graph.
 *
 * One dot per geocoded kg_places row, sized by mention count, with a
 * year-window slider and event-type filter. Doubles as the foundation
 * for "search this region" in Origin AI.
 */
import GeoMap from '../components/geomap/GeoMap.jsx'
import { usePageTitle } from '../hooks/usePageTitle.js'

export default function WorldMapPage() {
  usePageTitle('World Map')
  return (
    <div className="page world-map-page">
      <header className="page__header">
        <h1>World Map</h1>
        <p className="page__lead">
          Every geocoded place in the knowledge graph. Filter by year or
          event type to see how coverage shifts across centuries.
        </p>
      </header>
      <GeoMap />
    </div>
  )
}
